/**
 * Создание фрагментов DOM для результатов поиска
 */

// Получаем зависимости
var getDeps = function() {
  return window.SEARCH_RESULTS_DEPS || {};
};

// Функция для создания сообщения fuzzy search
function createFuzzySearchMessage(message) {
  if (!message) {
    return null;
  }
  var messageDiv = document.createElement('div');
  messageDiv.className = 'fuzzy-search-message new-result';
  messageDiv.setAttribute('data-search-result', 'true');
  messageDiv.style.animationDelay = '0ms';
  messageDiv.innerHTML = message;
  return messageDiv;
}

// Функция для создания фрагмента результатов
function createResultsFragment(entries, nothingFoundText, message, searchType, searchTerm, options) {
  var deps = getDeps();
  // Fallback escaper is never the identity (BL-047): & < > " ' always escaped.
  var escapeHtml = deps.escapeHtml || function(text) {
    return String(text === null || text === undefined ? '' : text)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  };
  var stripHtmlTags = deps.stripHtmlTags || function(text) { return text; };
  var getDictDescription = window.SEARCH_RESULTS_DICT_DESC ? window.SEARCH_RESULTS_DICT_DESC.getDictDescription : function() { return ''; };
  
  options = options || {};
  var skipAnimation = options.skipAnimation || false;
  
  var fragment = document.createDocumentFragment();
  var tempDiv = document.createElement('div');
  
  // Проверяем, является ли сообщение "Ничего не найдено"
  var isNothingFoundMessage = false;
  if (message && typeof nothingFoundText === 'string') {
    // Убираем HTML теги из сообщения для сравнения
    var messageText = message.replace(/<[^>]*>/g, '').trim();
    var nothingFoundTextClean = nothingFoundText.replace(/<[^>]*>/g, '').trim();
    // Проверяем, начинается ли сообщение с текста "Ничего не найдено"
    isNothingFoundMessage = messageText.indexOf(nothingFoundTextClean) === 0 || 
                           nothingFoundTextClean.indexOf(messageText) === 0 ||
                           messageText.toLowerCase().indexOf('nothing') !== -1 ||
                           messageText.toLowerCase().indexOf('ничего не найдено') !== -1 ||
                           messageText.toLowerCase().indexOf('nichts gefunden') !== -1 ||
                           messageText.toLowerCase().indexOf('rien') !== -1;
  }
  
  // Добавляем сообщение, если оно есть И если это не сообщение "Ничего не найдено" при пустых результатах
  // (сообщение "Ничего не найдено" будет показано в блоке else ниже)
  if (message && !(isNothingFoundMessage && (!entries || entries.length === 0))) {
    var messageDiv = createFuzzySearchMessage(message);
    if (messageDiv) {
      if (skipAnimation) {
        messageDiv.style.animation = 'none';
        messageDiv.style.opacity = '1';
        messageDiv.style.transform = 'translateY(0)';
      }
      fragment.appendChild(messageDiv);
    }
  }
  
  if (entries && entries.length > 0) {
    entries.forEach(function(entry, index) {
      var dictDesc = getDictDescription(entry.dictionary);
      // Используем source_table для проверки (это реальный технический код таблицы)
      // dictionary - это отображаемое имя, а source_table - технический код (например, "ScnTech_RU")
      var dictCode = entry.dictionary;
      var checkCode = entry.source_table || null;
      // Проверяем, является ли словарь стоматологическим (SCN/SNT) по техническому коду
      var isScn = checkCode && (checkCode.toUpperCase().substring(0, 3) === 'SCN' || checkCode.toUpperCase().substring(0, 3) === 'SNT');
      var scnAttr = isScn ? ' data-scn="1"' : '';
      
      // Добавляем класс new-result и задержку анимации для плавного каскадного появления
      var animationDelay = skipAnimation ? 0 : Math.min(index * 35, 400); // Ограничиваем макс. задержку 400мс
      var extraClass = skipAnimation ? '' : ' new-result';
      var styleAttr = skipAnimation ? '' : ' style="animation-delay: ' + animationDelay + 'ms"';
      
      // Stable GUID for URL anchors: source_table:source_rowid (never changes)
      var entryGuid = '';
      if (entry.guid) {
        entryGuid = entry.guid;
      } else if (entry.source_table && entry.source_rowid) {
        entryGuid = entry.source_table + ':' + entry.source_rowid;
      }
      var guidAttr = entryGuid ? ' data-guid="' + escapeHtml(entryGuid) + '"' : '';

      var html = '<div class="opredelenie' + extraClass + '"' + scnAttr + guidAttr + ' data-search-result="true"' + styleAttr + '>';
      html += '  <div class="zaglavie" tabindex="0">';
      // all_entries terms carry no HTML: the API `term` is PLAIN TEXT. Decode/strip it,
      // then escape — never concatenate it raw (BL-047: a stored `&lt;img onerror…&gt;`
      // headword became a live tag here). deps.stripHtmlTags drops keepR anyway.
      var displayTerm = entry.term || '';
      var cleanTerm = escapeHtml(stripHtmlTags(displayTerm));
      html += '    <div class="terms">' + cleanTerm + '</div>';
      html += '    <div class="dictname" data-dict-name="' + escapeHtml(entry.dictionary) + '" data-dict-code="' + escapeHtml(dictCode) + '" data-dict-desc="' + escapeHtml(dictDesc) + '">' + escapeHtml(entry.dictionary) + '</div>';
      // Блок действий статьи: кнопка-меню (⋮), видна только на раскрытом
      // термине (десктоп; CSS-гейт term-menu.css). Пункты — «Редактировать»
      // (если есть права: КРИТИЧНО используем source_rowid, оригинальный
      // rowid в исходной таблице, а не rowid из all_entries) и «Отправить в
      // Telegram» (guid; видимость пункта — body.tg-linked, account.js). На
      // touch эти же кнопки читает long-tap sheet (term-actions.js, 40-frontend/p_40-longpress.md).
      var uiLang = 'en';
      try {
        uiLang = window.SEARCH_LANGUAGE ? window.SEARCH_LANGUAGE.getCurrentLang() : 'en';
      } catch (e) { /* default en */ }
      var uiTexts = (window.LANG_TEXTS && window.LANG_TEXTS[uiLang]) || {};

      // «Редактировать» for EVERY visitor (owner 2026-10-24, msg 1174): without rights on this
      // dictionary the button carries data-edit-gate="1" and account.js opens the account tab.
      var editSourceTable = entry.source_table || dictCode;
      // source_rowid first, then the guid, then rowid, then id
      var editRowid = entry.source_rowid;
      if (!editRowid && entry.guid) {
        var guidParts = entry.guid.split(':');
        if (guidParts.length === 2 && guidParts[1]) {
          editRowid = parseInt(guidParts[1], 10) || 0;
        }
      }
      editRowid = editRowid || entry.rowid || entry.id || 0;
      // Read-only dictionaries (window.READ_ONLY_DICTS, BL-027) get no «Edit» item at all.
      var readOnlyDicts = window.READ_ONLY_DICTS || [];
      var canEdit = !!(editSourceTable && editRowid) && readOnlyDicts.indexOf(editSourceTable) === -1;
      var editRight = false;
      if (canEdit && window.EDITOR_CONFIG && window.EDITOR_CONFIG.canEdit) {
        var editable = window.EDITOR_CONFIG.editableDictionaries || {};
        editRight = !!(editable['*'] || editable[editSourceTable]);
      }
      var canSend = !!entryGuid;

      if (canEdit || canSend) {
        var moreTitle = escapeHtml(uiTexts.term_menu_more || 'More actions');
        html += '    <div class="zaglavie-actions">';
        html += '      <button type="button" class="zaglavie-more-btn" aria-haspopup="menu" aria-expanded="false" title="' + moreTitle + '" aria-label="' + moreTitle + '"><i class="bi bi-three-dots-vertical"></i></button>';
        html += '      <div class="zaglavie-more-menu" role="menu">';
        if (canEdit) {
          var termEscaped = escapeHtml(displayTerm);
          var editLabel = escapeHtml(uiTexts.term_menu_edit || 'Edit');
          html += '        <button type="button" role="menuitem" class="edit-entry-btn" data-dict-code="' + escapeHtml(editSourceTable) + '" data-rowid="' + editRowid + '" data-term="' + termEscaped + '"' + (editRight ? '' : ' data-edit-gate="1"') + ' title="' + editLabel + '"><i class="bi bi-pencil"></i><span>' + editLabel + '</span></button>';
        }
        if (canSend) {
          var tgTitle = escapeHtml(uiTexts.tg_send_term_title || 'Send to my Telegram');
          html += '        <button type="button" role="menuitem" class="tg-send-btn" title="' + tgTitle + '" aria-label="' + tgTitle + '"><i class="bi bi-send"></i><span>' + tgTitle + '</span></button>';
        }
        html += '      </div>';
        html += '    </div>';
      }
      html += '  </div>';
      html += '  <div class="descr">' + entry.definition + '</div>';
      html += '</div>';
      tempDiv.innerHTML = html;
      while (tempDiv.firstChild) {
        fragment.appendChild(tempDiv.firstChild);
      }
    });
    // Добавляем небольшой отступ внизу
    var spacer = document.createElement('div');
    spacer.setAttribute('data-search-result', 'true');
    spacer.innerHTML = '<br><br>';
    while (spacer.firstChild) {
      var child = spacer.firstChild;
      // Помечаем все элементы (включая <br>) как результаты поиска
      if (child.nodeType === 1) { // Element node
        child.setAttribute('data-search-result', 'true');
      }
      fragment.appendChild(child);
    }
  } else {
    // Используем формат fuzzy-search-message как у первого сообщения
    var messageDiv = document.createElement('div');
    messageDiv.className = 'fuzzy-search-message new-result';
    messageDiv.setAttribute('data-search-result', 'true');
    messageDiv.style.animationDelay = '0ms';
    
    // Получаем части текста ссылки из LANG_TEXTS
    var linkPrefix = '';
    var linkText = '';
    var linkSuffix = '';
    var scientoUrl = 'https://sciento.org/';
    var enableAiPrefix = '';
    var enableAiLink = '';
    var enableAiSuffix = '';
    
    if (typeof LANG_TEXTS !== 'undefined' && window.SEARCH_LANGUAGE) {
      var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
      if (LANG_TEXTS[currentLang]) {
        linkPrefix = LANG_TEXTS[currentLang].nothing_found_link_prefix || '';
        linkText = LANG_TEXTS[currentLang].nothing_found_link_text || '';
        linkSuffix = LANG_TEXTS[currentLang].nothing_found_link_suffix || '';
        // Получаем текст для предложения включить AI режим
        enableAiPrefix = LANG_TEXTS[currentLang].nothing_found_enable_ai_prefix || '';
        enableAiLink = LANG_TEXTS[currentLang].nothing_found_enable_ai_link || '';
        enableAiSuffix = LANG_TEXTS[currentLang].nothing_found_enable_ai_suffix || '';
      }
    }
    
    // Создаем HTML с текстом
    var html = escapeHtml(nothingFoundText);
    
    // Новая логика предложения смены языка
    if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getSuggestedLanguage) {
      var suggestedLang = window.SEARCH_LANGUAGE.getSuggestedLanguage(searchTerm);
      if (suggestedLang && suggestedLang !== currentLang) {
        var suggestPrefix = LANG_TEXTS[currentLang].nothing_found_suggest_lang_prefix || '';
        var suggestLinkText = LANG_TEXTS[currentLang].nothing_found_suggest_lang_link || '%s';
        var suggestSuffix = LANG_TEXTS[currentLang].nothing_found_suggest_lang_suffix || '';
        
        // Получаем название языка для вставки в ссылку (например, "английском")
        var langName = LANG_TEXTS[currentLang]['lang_suggest_' + suggestedLang] || suggestedLang;
        suggestLinkText = suggestLinkText.replace('%s', langName);
        
        html += '<br>';
        html += escapeHtml(suggestPrefix);
        html += '<a href="#" class="suggest-lang-link" data-lang="' + escapeHtml(suggestedLang) + '" data-search-term="' + escapeHtml(searchTerm) + '">' + escapeHtml(suggestLinkText) + '</a>';
        html += escapeHtml(suggestSuffix);
      }
    }
    
    // Сначала добавляем предложение включить AI режим, если он выключен
    if (searchType !== 'smart' && enableAiPrefix && enableAiLink && enableAiSuffix && searchTerm) {
      html += escapeHtml(enableAiPrefix);
      // Создаем ссылку для включения AI режима и повторного поиска
      var enableAiLinkHtml = '<a href="#" class="enable-ai-link" data-search-term="' + escapeHtml(searchTerm) + '">' + escapeHtml(enableAiLink) + '</a>';
      html += enableAiLinkHtml;
      html += escapeHtml(enableAiSuffix);
    }
    
    // Затем добавляем ссылку на внешний сайт sciento.org
    if (linkPrefix || linkText || linkSuffix) {
      html += ' ' + escapeHtml(linkPrefix);
      if (linkText) {
        html += '<a href="' + escapeHtml(scientoUrl) + '" target="_blank" rel="noopener noreferrer" style="color: var(--color-brand-primary); text-decoration: underline; display: inline-flex; align-items: center; gap: 4px;"><img src="/static/img/sciento-favicon.svg" alt="" style="width: 16px; height: 16px; vertical-align: middle; display: inline-block;">' + escapeHtml(linkText) + '</a>';
      }
      html += escapeHtml(linkSuffix);
    }
    
    messageDiv.innerHTML = html;
    fragment.appendChild(messageDiv);

    // Чипы «Возможно, вы имели в виду» (suggestions приходят из API при
    // полностью пустой выдаче; клик по чипу — поиск этого термина).
    var suggestions = (options && options.suggestions) || null;
    if (suggestions && suggestions.length > 0) {
      var didYouMean = '';
      if (typeof LANG_TEXTS !== 'undefined' && window.SEARCH_LANGUAGE) {
        var sugLang = window.SEARCH_LANGUAGE.getCurrentLang();
        didYouMean = (LANG_TEXTS[sugLang] && LANG_TEXTS[sugLang].nothing_found_did_you_mean) || '';
      }
      var sugDiv = document.createElement('div');
      sugDiv.className = 'nothing-found-suggestions new-result';
      sugDiv.setAttribute('data-search-result', 'true');
      var sugHtml = '';
      if (didYouMean) {
        sugHtml += '<div class="nothing-found-suggestions-title">' + escapeHtml(didYouMean) + '</div>';
      }
      sugHtml += '<div class="nothing-found-suggestions-chips">';
      suggestions.forEach(function(sTerm) {
        sugHtml += '<button type="button" class="suggestion-chip" data-term="' + escapeHtml(sTerm) + '">' + escapeHtml(sTerm) + '</button>';
      });
      sugHtml += '</div>';
      sugDiv.innerHTML = sugHtml;
      sugDiv.addEventListener('click', function(e) {
        var chip = e.target.closest ? e.target.closest('.suggestion-chip') : null;
        if (!chip) return;
        e.preventDefault();
        var chipTerm = chip.getAttribute('data-term');
        if (!chipTerm) return;
        var searchInput = document.getElementById('search');
        if (searchInput) searchInput.value = chipTerm;
        if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
          window.SEARCH_LANGUAGE.switchLanguage(window.SEARCH_LANGUAGE.getCurrentLang(), chipTerm, searchType);
        } else if (window.SEARCH_API && window.SEARCH_API.loadSearchResults) {
          window.SEARCH_API.loadSearchResults(chipTerm, searchType);
        }
      });
      fragment.appendChild(sugDiv);
    }

    // Добавляем обработчик клика на ссылку включения AI режима
    if (searchType !== 'smart' && searchTerm) {
      // Используем делегирование событий для надежности
      var enableAiLinkHandler = function(e) {
        var target = e.target;
        // Проверяем, что клик был по ссылке или её дочернему элементу
        while (target && !target.classList.contains('enable-ai-link')) {
          target = target.parentElement;
        }
        if (!target || !target.classList.contains('enable-ai-link')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        var termToSearch = target.getAttribute('data-search-term') || searchTerm;
        if (termToSearch) {
          // Включаем AI режим
          var searchModeToggle = document.getElementById('search-mode-toggle');
          var searchTypeHidden = document.getElementById('search-type-hidden');
          if (searchModeToggle && searchTypeHidden) {
            searchModeToggle.setAttribute('data-mode', 'smart');
            searchModeToggle.classList.add('active');
            searchTypeHidden.value = 'smart';
            // Обновляем title
            if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.getCurrentLang) {
              var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
              if (typeof LANG_TEXTS !== 'undefined' && LANG_TEXTS[currentLang]) {
                var searchTypeLabel = LANG_TEXTS[currentLang].search_type_label || 'Mode';
                searchModeToggle.title = searchTypeLabel + ': Smart';
              }
            }
            // Сохраняем выбор
            if (window.SEARCH_UTILS && window.SEARCH_UTILS.saveSearchType) {
              window.SEARCH_UTILS.saveSearchType('smart');
            }
          }
          // Запускаем поиск с AI режимом и обновляем URL
          if (window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
            var currentLang = window.SEARCH_LANGUAGE.getCurrentLang();
            window.SEARCH_LANGUAGE.switchLanguage(currentLang, termToSearch, 'smart');
          } else if (window.SEARCH_API && window.SEARCH_API.loadSearchResults) {
            window.SEARCH_API.loadSearchResults(termToSearch, 'smart');
          } else if (window.loadSearchResults) {
            window.loadSearchResults(termToSearch, 'smart');
          } else {
            // Fallback: используем performSearch
            var searchInput = document.getElementById('search');
            if (searchInput) {
              searchInput.value = termToSearch;
            }
            if (window.performSearch) {
              var fakeEvent = { preventDefault: function() {} };
              window.performSearch(fakeEvent);
            }
          }
        }
      };
      // Добавляем обработчик на элемент messageDiv, используя делегирование
      messageDiv.addEventListener('click', enableAiLinkHandler);
    }

    // Добавляем обработчик клика на ссылку предложения языка
    if (searchTerm) {
      var suggestLangLinkHandler = function(e) {
        var target = e.target;
        while (target && !target.classList.contains('suggest-lang-link')) {
          target = target.parentElement;
        }
        if (!target || !target.classList.contains('suggest-lang-link')) {
          return;
        }
        e.preventDefault();
        e.stopPropagation();
        
        var newLang = target.getAttribute('data-lang');
        var termToSearch = target.getAttribute('data-search-term') || searchTerm;
        
        if (newLang && window.SEARCH_LANGUAGE && window.SEARCH_LANGUAGE.switchLanguage) {
          // Переключаем язык и запускаем поиск
          window.SEARCH_LANGUAGE.switchLanguage(newLang, termToSearch, searchType);
        }
      };
      messageDiv.addEventListener('click', suggestLangLinkHandler);
    }
  }
  
  return fragment;
}

// Экспорт для использования в других модулях results/
window.SEARCH_RESULTS_FRAGMENT = {
  createResultsFragment: createResultsFragment,
  createFuzzySearchMessage: createFuzzySearchMessage
};

